export const TeamInfoTheme = {
    /** 主视觉背景卡片 */
    BackgroundImageCard: 'https://p0.meituan.net/ingee/554b1d4cc478c28fcf8e47c62c6f99399517.png',
    /** Call 值 Icon (Call 值旁) */
    CallIcon: 'https://p0.meituan.net/ingee/b0095774ec171c119327536edbc73960734.png',
    /** 奖励按钮 */
    RewardButtonImage: 'https://p0.meituan.net/ingee/45553e7317e25bfa4bf9d2bcf5b3bec110751.png',
    /** 邀请打 Call 按钮 */
    InviteCallButtonImage: 'https://p0.meituan.net/ingee/8b79ef8ce2931b0d3acce7a052fa647822814.png',
    /** 排行榜按钮 */
    RankingListButtonImage: 'https://p0.meituan.net/ingee/274c625bdf5c715295496265629ac3de9810.png',
    /** 问号图标 */
    QuestionIcon: 'https://img.meituan.net/makerjiulv/68e502e8872894dd32c15a7661f0c62518760.png',
    /** 右箭头图标 */
    RightIcon: 'https://p0.meituan.net/ingee/f085fb28479533d84ef9a80da0de2946363.png'
};
export const TeamRecommendTheme = {
    /** 背景图 */
    BackgroundImage: 'https://p0.meituan.net/ingee/41ff73c6483bda356fc748b921a6236c8881.png',
    /** 标题图 */
    TitleImage: 'https://p0.meituan.net/ingee/9d3cb55d6a8aa110f187afbb74f0f2ab4920.png',
    TitleHeaderImage: 'https://p0.meituan.net/ingee/9d3cb55d6a8aa110f187afbb74f0f2ab4920.png',
    /** 顶部操作区 - 加入或创建队 Icon */
    TopActionJoinIcon: 'https://p0.meituan.net/ingee/e3f980fc95dd3065f3c5261330e642bb1491.png',
    /** 顶部操作区 - 邀好友打Call Icon */
    TopActionInviteIcon: 'https://p0.meituan.net/ingee/157b41ceec032bf6d53088dfafe7bab92099.png',
    /** 顶部操作区 - 一起赢免单 Icon */
    TopActionWinIcon: 'https://p0.meituan.net/ingee/b6be7c2fc36d160bf71d274f57de29041609.png',
    /** 顶部操作区 - 箭头分隔符 */
    TopActionArrow: 'https://p0.meituan.net/ingee/01d0b7091586c9ce48ff9756c809ca70297.png',
    /** Call值图标 */
    CallIcon: 'https://p0.meituan.net/ingee/b0095774ec171c119327536edbc73960734.png',
    /** 空状态图 */
    EmptyImage: 'https://p0.meituan.net/travelcube/70ebeaaad24595c07aa27e01375d104512206.png',
    /** 创建战队按钮 */
    CreateTeamButton: 'https://p0.meituan.net/ingee/73a924ea5cf3ea83caba8315600d147243650.png',
    /** 复选框选中图标 */
    CheckboxCheckedIcon: 'https://p0.meituan.net/ingee/cc3105e3bf3a9f19cee0e74aecdc476a440.png'
};
export const TeamStageResultTheme = {
    /** 背景卡片 */
    BackgroundCard: 'https://p0.meituan.net/ingee/44beee20529f92225f1f1aed4a2ce2597875.png',
    /** Call值图标 */
    CallIcon: 'https://p0.meituan.net/ingee/163d0b40bd592c7129d73da9f2067659731.png',
    /** 奖励记录按钮 */
    RewardRecordButton: 'https://p0.meituan.net/ingee/45553e7317e25bfa4bf9d2bcf5b3bec110751.png',
    /** 奖励记录按钮（无队伍状态） */
    RewardRecordButtonNoTeam: 'https://p0.meituan.net/ingee/fb87277cfe6f149c653219ac37161d5f10950.png',
    /** 去预约按钮 */
    SubscribeButton: 'https://p0.meituan.net/ingee/a357c14f6fffa2085a54298a6688739126250.png',
    /** 去使用按钮 */
    UseButton: 'https://p0.meituan.net/ingee/2170c39c799a490237a471c7e99fd9dc25292.png',
    /** 查看获奖名单按钮 */
    ViewWinnerListButton: 'https://p0.meituan.net/ingee/3abfaf24023bb92370f230c4184ce39a29899.png',
    /** 查看获奖名单按钮（无队伍状态） */
    ViewWinnerListButtonNoTeam: 'https://p0.meituan.net/ingee/453d43a64f5a367512c1d5e1d76eb1d829894.png',
    /** 排行榜按钮 */
    RankingButton: 'https://p0.meituan.net/ingee/274c625bdf5c715295496265629ac3de9810.png'
};
export const RankingListTheme = {
    /** 弹窗背景图 */
    BackgroundImage: 'https://p0.meituan.net/ingee/749842ea46c2143bb56b605a91e6a3f313571.png',
    /** 标题图 */
    TitleImage: 'https://p0.meituan.net/ingee/9915fa31c6c5be9c98afe624d342a1716911.png',
    /** 关闭按钮 */
    CloseButton: 'https://p0.meituan.net/ingee/62c376413d9d4422206d04f2c916c280721.png',
    /** Top1 背景 */
    Top1Background: 'https://p0.meituan.net/ingee/dbf524939057c77045e143e44787d5972931.png',
    /** Top1 头像边框 */
    Top1AvatarBorder: 'https://p0.meituan.net/ingee/c6958ed09410b9cbb4dbe4bc96b9a0321236.png',
    /** Top1 排名图标 */
    Top1RankingIcon: 'https://p0.meituan.net/ingee/afee71895696aa29f196909cdf28e1b01750.png',
    /** Top2 背景 */
    Top2Background: 'https://p0.meituan.net/ingee/747db3051b131f9be0cdc17ec219ac722976.png',
    /** Top2 头像边框 */
    Top2AvatarBorder: 'https://p0.meituan.net/ingee/e7aff6feac95a3adbd60288512fe8f631391.png',
    /** Top2 排名图标 */
    Top2RankingIcon: 'https://p0.meituan.net/ingee/9dac7d48da02725bb97ee9a67b44b2c22058.png',
    /** Top3 背景 */
    Top3Background: 'https://p0.meituan.net/ingee/365e5d4be1b711724e99251f339c13f53075.png',
    /** Top3 头像边框 */
    Top3AvatarBorder: 'https://p0.meituan.net/ingee/cc5aa569c67883f9755abc8da766238b1447.png',
    /** Top3 排名图标 */
    Top3RankingIcon: 'https://p0.meituan.net/ingee/cd15afc71c15ae3abfcdb26dcb2a379d2369.png',
    /** 戳一戳按钮 */
    PokeButton: 'https://p0.meituan.net/ingee/4a29556d085a31209aabdb21a73ebab49023.png'
};
export const RewardRecordsTheme = {
    /** 弹窗背景图 */
    BackgroundImage: 'https://p0.meituan.net/ingee/749842ea46c2143bb56b605a91e6a3f313571.png',
    /** 标题图 */
    TitleImage: 'https://p0.meituan.net/ingee/420f23fc8427e0ecd869ce35f03095993438.png',
    /** 关闭按钮 */
    CloseButton: 'https://p0.meituan.net/ingee/62c376413d9d4422206d04f2c916c280721.png',
    /** 空状态图标 */
    EmptyIcon: 'https://p0.meituan.net/ingee/07b6a302ba298c7b4ff073ba859eb05450442.png'
};
